import React from "react";

function TxtIcon({ width = "20px", height = "20px", color = "#7030A0" }) {
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 90.604 90.604"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M58.596,0H12.255v90.604h66.094v-63.73L54.868,10.66L58.596,0z M35.35,38.153h-6.011v17.835h-4.998V38.153h-5.913v-4.181 H35.35V38.153z M57.132,33.972h16.922v4.181h-6.012v17.835h-4.997V38.153h-5.913V33.972z M55.6,33.972l-6.206,10.747l6.533,11.269 h-5.75l-1.993-3.984c-0.815-1.536-1.339-2.68-1.959-3.951H46.16c-0.458,1.271-1.014,2.416-1.699,3.951l-1.829,3.984h-5.684 l6.369-11.139l-6.141-10.877h5.717l1.928,4.017c0.652,1.34,1.143,2.418,1.665,3.66h0.065c0.522-1.404,0.946-2.385,1.503-3.66 l1.861-4.017H55.6z" />
            <polygon points="63.235,0.097 60.216,8.734 78.348,21.254 " />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default TxtIcon;
